import React, { Fragment } from 'react';

/**
 * # cortex:react-ui-std:helper:unwrapFragment
 * Deprecated: Use Cellula components instead
 */
export function unwrapFragment(children: React.ReactNode): React.ReactElement[] {
	const childArr = React.Children.toArray(children) as React.ReactElement[];

	const newArr: React.ReactElement[] = childArr.reduce<React.ReactElement[]>((builder, child) => {
		if (child.type === Fragment) {
			return builder.concat(unwrapFragment(child.props.children));
		}

		builder.push(child);

		return builder;
	}, []);

	return newArr;
}
